module.exports = __webpack_public_path__ + "static/banner-mobile-gruppo-pam-95f00e752ae1504779ff195f666da7ff.webp";